import { module, bootstrap } from "angular";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import sportIconDirective from "../../partials/sport-icon/sport-icon.directive";
import teamIconDirective from "../../partials/icons/team-icon/team-icon.directive";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";
import { addGTMTag, generalConfig, /*rollbarConfig*/ } from "../general";
import "./futures-mini.scss";
import flagIconDirective from "../../partials/icons/flag-icon/flag-icon.directive";
import { nthFilter } from "../../filters/nth.filter";
import { GeneralService } from "../../services/general.service";
import futuresMiniBlockComponent from "./futures-mini.component";

function loadSingleSiFuturesMini(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		if (config.sportCode) {
			// remove case-sensitivity for sport codes
			config.sportCode = config.sportCode.toUpperCase();
			// determine target element
			if (!config.targetElementID) {
				config.targetElementID = "si-external-futures-mini";
			}
			const targetElement = document.getElementById(config.targetElementID);
			if (targetElement !== null) {
				if (config.debugMode) {
					targetElement.innerHTML = "Loading Futures Mini Block...";
				}
		
				if (config.publicationTheme) {
					
					require("../../publisher-themes/" + config.publicationTheme + ".scss");
				}

				targetElement.innerHTML = "<si-external-futures-mini></si-external-futures-mini>";
	
				addGTMTag(config);

				module("siExternalFuturesMini", [require("angular-sanitize"), /* 'ngAnimate',*/ /*require("ng-rollbar")*/])
					.value("configurationObject", config)
					.value("apiDomain", process.env.API_DOMAIN)
					.constant("blockDomain", process.env.BLOCK_DOMAIN)
					.constant("cdnDomain", process.env.CDN_DOMAIN)
					.service("sportDataService", SportDataService)
					.filter("nth", nthFilter)
					.service("generalService", GeneralService)
					.service("matchService", MatchService)
					.directive("teamIconSport", teamIconDirective)
					.directive("flagIconCountry", flagIconDirective)
					.directive("sportIconCode", sportIconDirective)
					.config(generalConfig)
					.component("siExternalFuturesMini", futuresMiniBlockComponent)
					// .config(["RollbarProvider", rollbarConfig]);

				bootstrap(targetElement, ["siExternalFuturesMini"], {strictDi: true});

				resolve();

			} else {
				reject(`Target element (#${config.targetElementID}) not found`);
			}
		} else {
			reject("Configuration object found, but required parameter 'sportCode' not found within");
		}
	});
}

function loadSiFuturesMini(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		console.log("SI Loader script called");
		if (config) {
			if (Array.isArray(config)) {
				config.reduce((previousPromise, nextConfig) => {
					return previousPromise.then(() => {
						return loadSingleSiFuturesMini(nextConfig);
					}, (err) => {
						console.error("Futures Mini Block failed: " + err);
						return loadSingleSiFuturesMini(nextConfig);
					});
				}, Promise.resolve()).then(resolve);
			} else {
				loadSingleSiFuturesMini(config).then(() => {
					console.log("Futures Mini Block Successfully Loaded");
					resolve();
				}, (err) => {
					console.log(`Futures Mini Block failed: ${err}`);
					reject(`Futures Mini Block failed: ${err}`);
				});
			}
		} else {
			console.log("Configuration object (config) not found");
			reject("Configuration object (config) not found");
		}
	});
}

if (typeof window !== undefined) {
	window["loadSiFuturesMini"] = loadSiFuturesMini;
}
export { loadSiFuturesMini };